export default __webpack_public_path__ + "static/media/tax-loss-harvesting.8527fc9b.svg";